<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Impresión de precios actualizados por dia</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <label>Fecha</label>
              <input v-model="current.fecha" class="form-control" type="date" />
            </div>
            <div class="col-6">
              <TiendaSelectComponent :current="current" />
            </div>
          </div>
          <div v-if="current.fecha" class="modal-footer">
            <div class="row">
              <div class="col-sm-12">
                <div class="dropdown">
                  <button
                    v-if="current.tienda && current.fecha"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    class="btn btn-info dropdown-toggle"
                    aria-expanded="false"
                  >
                    <i class="fas fa-download"></i>
                    Generar Reporte
                  </button>
                  <div
                    aria-labelledby="dropdownMenuButton"
                    class="dropdown-menu"
                    x-placement="bottom-start"
                    style="
                      position: absolute;
                      transform: translate3d(0px, 30px, 0px);
                      top: 0px;
                      left: 0px;
                      will-change: transform;
                    "
                  >
                    <a @click="GenerarReporteXls(current)" class="dropdown-item"
                      ><i class="far fa-file-alt"></i> - XLS</a
                    >
                    <a @click="GenerarReporte(current)" class="dropdown-item"
                      ><i class="far fa-file-alt"></i> - PDF</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      current: {},
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    GenerarReporte(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      if (current.tienda) {
        window.open(
          `${baseApiUrl}/cat/reporte/?&report_name=catalogos/preciosActualizadosEnTabla.jrxml&fecha=${current.fecha}&tienda=${current.tienda}`
        );
      } else {
        window.open(
          `${baseApiUrl}/cat/reporte/?&report_name=catalogos/preciosActualizadosEnTabla.jrxml&fecha=${current.fecha}`
        );
      }
      current.tienda = "";
      current.fecha = "";
    },
    GenerarReporteXls(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      if (current.tienda) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=catalogos/preciosActualizadosEnTabla.jrxml&fecha=${current.fecha}&tienda=${current.tienda}`
        );
      } else {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=catalogos/preciosActualizadosEnTabla.jrxml&fecha=${current.fecha}`
        );
      }
      current.tienda = "";
      current.fecha = "";
    },
    refreshPrecios(current) {
      let self = this;
      ProductosService.getById(current.sku).then((response) => {
        self.current = response.data;
      });
      self.showModalAddPrecios();
    },

    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.sku },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ProductosService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalAddPrecios() {
      let self = this;
      $("#modalAddPrecios").modal();
    },
  },
};
</script>